const initialState = {
    appName: "Redux Shoping Cart App",
};

const appInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default appInfoReducer;
